import { Pipe, PipeTransform } from '@angular/core';
import { normalizeFontWeight } from '../lib/normalize-font-weight';

@Pipe({
  name: 'fontWeightName',
})
export class FontWeightNamePipe implements PipeTransform {
  transform(weight: string): string {
    weight = normalizeFontWeight(weight);
    if (weight === '100') return 'Thin';
    if (weight === '200') return 'Extra Light';
    if (weight === '300') return 'Light';
    if (weight === '400') return 'Regular';
    if (weight === '500') return 'Medium';
    if (weight === '600') return 'Semi Bold';
    if (weight === '700') return 'Bold';
    if (weight === '800') return 'Extra Bold';
    if (weight === '900') return 'Black';

    console.log(weight);
    return weight;
  }
}
